export default {
    loaderVisible:false,
    loaderMessage:'Cargando...'
}